export const SET_LANCAMENTO = 'SET_LANCAMENTO';
export const SET_LANCAMENTO_LOADING = 'SET_LANCAMENTO_LOADING';
export const SET_LOGS_LOADING = 'SET_LOGS_LOADING';
export const SET_LOGS = 'SET_LOGS';
export const SET_DISCOUT_LOGS_LOADING = 'SET_DISCOUT_LOGS_LOADING';
export const SET_DISCOUNT_LOGS = 'SET_DISCOUNT_LOGS';
